import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useGroupAdd } from "hooks/citajteo/dl_group/useGroupAdd";
import { QUERY_KEYS } from "constant/react_query";
import DlGroupForm, {
  DL_GROUP_EMPTY_FORM,
  DlGroupFormState,
} from "components/admin/common/dl_group/DlGroupForm/DlGroupForm";
import toast from "react-hot-toast";
import { useForm, useFieldArray } from "react-hook-form";
import { UnitFieldCond } from "common/api/citajteo/dl_group/citajteo_group";
import { fCondObFormat } from "components/admin/common/dl_group/DlGroupForm/DlGroupForm.logic";

const DlGroupNew: React.FC = () => {
  const navigate = useNavigate();
  const { groupAddMutate } = useGroupAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_GROUP_SEARCH],
  });
  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<DlGroupFormState>({
    defaultValues: DL_GROUP_EMPTY_FORM,
  });
  const [errorText, setErrorText] = useState("");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "fieldConditions",
  });

  const fieldArrayHandlers = { fields, append, remove };

  const handleSubmit = (form: DlGroupFormState) => {
    setErrorText("");

    const trimmedSlug = form.slug.trim();

    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    let fCond: UnitFieldCond = fCondObFormat(form.fieldConditions);

    groupAddMutate(
      {
        slug: trimmedSlug,
        fCond,
      },
      {
        onSuccess: () => {
          toast.success("Uspešno dodavanje odrednice.");
          navigate("/admin-dashboard/dl-group-li");
        },
        onError: (error) => {
          console.error("Error adding group:", error);
          toast.error("Greška prilikom dodavanja odrednice.");
        },
      },
    );
  };

  const handleReset = () => {
    reset(DL_GROUP_EMPTY_FORM);
    setErrorText("");
  };

  return (
    <FullWidth>
      <div className="App">
        <DlGroupForm
          control={control}
          fieldArrayHandlers={fieldArrayHandlers}
          errorText={errorText}
          onSubmit={handleFormSubmit(handleSubmit)}
          onReset={handleReset}
        />
      </div>
    </FullWidth>
  );
};

export default DlGroupNew;

const FullWidth = styled.div`
  width: 100%;
`;
